/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeAUpRightIcon16Light } from './ArrowShapeAUpRightIcon16Light';
import { ArrowShapeAUpRightIcon16Regular } from './ArrowShapeAUpRightIcon16Regular';
import { ArrowShapeAUpRightIcon16Solid } from './ArrowShapeAUpRightIcon16Solid';
import { ArrowShapeAUpRightIcon20Light } from './ArrowShapeAUpRightIcon20Light';
import { ArrowShapeAUpRightIcon20Regular } from './ArrowShapeAUpRightIcon20Regular';
import { ArrowShapeAUpRightIcon20Solid } from './ArrowShapeAUpRightIcon20Solid';
import { ArrowShapeAUpRightIcon24Regular } from './ArrowShapeAUpRightIcon24Regular';
import { ArrowShapeAUpRightIcon24Solid } from './ArrowShapeAUpRightIcon24Solid';
import { ArrowShapeAUpRightIcon32Regular } from './ArrowShapeAUpRightIcon32Regular';
import { ArrowShapeAUpRightIcon64Regular } from './ArrowShapeAUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeAUpRightIcon16Light,
        regular: ArrowShapeAUpRightIcon16Regular,
        solid: ArrowShapeAUpRightIcon16Solid,
    },
    20: {
        light: ArrowShapeAUpRightIcon20Light,
        regular: ArrowShapeAUpRightIcon20Regular,
        solid: ArrowShapeAUpRightIcon20Solid,
    },
    24: {
        regular: ArrowShapeAUpRightIcon24Regular,
        solid: ArrowShapeAUpRightIcon24Solid,
    },
    32: {
        regular: ArrowShapeAUpRightIcon32Regular,
    },
    64: {
        regular: ArrowShapeAUpRightIcon64Regular,
    },
};
export var ArrowShapeAUpRightIcon = forwardRef('ArrowShapeAUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
